import React from 'react'
import bookStyles from './styles.module.scss'

const BookMeeting = ({ title, content }) => {
  return (
    <div className={bookStyles.bookmeeting}>
      <h3>{title}</h3>
      <p>{content}</p>
      <button type="submit" className={bookStyles.bookButton}>
        <a href="https://calendly.com/michele-zucca81" target="blank">
          {' '}
          Book Meeting
        </a>
      </button>
    </div>
  )
}
export default BookMeeting
